module.exports = __webpack_public_path__ + "static/media/calendar.8598cf23.svg";